<template>
  <!-- 折线图 -->
  <div :id="lineChart2Info.nodeId"></div>
</template>

<script>
export default {
  name: "LineChart2",
  props:["lineChart2Info"],
  data(){
    return {
    //   lineChart2Info:{
        // nodeId:'detailPart3Echart1',
        // data1: [5, 4, 7, 9, 4, 4, 5, 7, 9, 4],//数据
        // data2: [ 4, 7, 9, 4, 4, 5, 7, 9, 4,1],//数据
        // data3: [ 4, 9, 4, 4, 5, 7, 9, 4,1,6],//数据
        // data4: [ 6,4, 9, 4, 4, 5, 7, 9, 4,1],//数据
        // dataName:['播放量','点赞量','评论量','分享量'],
        // smooth:true,//平滑
        // xAxisData:['2s', '4s', '6s', '10s', '12s', '14s', '18s', '20s', '22s', '24s'],
        // min:14, //y轴的最小值
        // max:0, //y轴最大值 
        // interval:2, //值之间的间隔
        // yAxisName: '',
        // tooltipName:'用户占比',
        // unit:'%'
    //   }
    }
  },
  computed:{
    
  },
  methods:{
    lineChart2(lineChart2Info){
      var seriesObj=[{
          name:lineChart2Info.dataName[0],
          hoverAnimation: false,
          symbolSize: 0,
          color: '#FF6F28',
          data: lineChart2Info.data1,
          type: 'line',
          smooth: lineChart2Info.smooth,//平滑
        },{
          name:lineChart2Info.dataName[1],
          hoverAnimation: false,
          symbolSize: 0,
          color: '#31C270',
          data: lineChart2Info.data2,
          type: 'line',
          smooth: lineChart2Info.smooth,//平滑
        },{
          name:lineChart2Info.dataName[2],
          hoverAnimation: false,
          symbolSize: 0,
          color: '#7F6FF6',
          data: lineChart2Info.data3,
          type: 'line',
          smooth: lineChart2Info.smooth,//平滑
        }]
        if(lineChart2Info.data4){
            seriesObj.push({
            name:lineChart2Info.dataName[3],
            hoverAnimation: false,
            symbolSize: 0,
            color: '#55C5FF',
            data: lineChart2Info.data4,
            type: 'line',
            smooth: lineChart2Info.smooth,//平滑
          })
        }

      this.$echarts.dispose(document.getElementById(lineChart2Info.nodeId));
      var myChart = this.$echarts.init(document.getElementById(lineChart2Info.nodeId));
      myChart.setOption( {
        grid:{
          x:50,
          y:56,
          x2:0,
          y2:20
        },
        legend: {
          //  icon:'triangle',
          left: 'left'
        },
        tooltip : {
          trigger: 'axis',
          // formatter: '{b0}<br/>'+lineChart2Info.tooltipName+'：{c0}'+lineChart2Info.unit+'',
          confine: true,//浮窗不超出屏幕范围
          textStyle: {
            fontSize: 12,
            color: '#333'
          },
          backgroundColor: '#fff',
          borderRadius: 4,  
          axisPointer : {            // 坐标轴指示器，坐标轴触发有效
            type : 'line',         // 默认为直线，可选为：'line' | 'shadow'
            lineStyle : {          // 直线指示器样式设置
                color: '#333',
                width: 0.2,
                type: 'solid'
            },
            z: 2,//竖线在圆圈后面
          },
          extraCssText:'box-shadow:0 0 18px rgba(0,0,0,0.2)'//提示框阴影
        },
        xAxis: {
            type: 'category',
            data: lineChart2Info.xAxisData,
            axisLine:{
                show:true,//去除y轴线
                lineStyle: {
                    color: '#eee',
                    width: 0.8, //这里是为了突出显示加上的  
                }
            },
            axisLabel: {
                  textStyle: {
                      color:  '#999' , //坐标字值得具体的颜色
                  }
              },
            axisTick:{
                show:false//去除y轴刻度
            },
        },
        yAxis: {
            type: 'value',
            scale:true,
            name: lineChart2Info.yAxisName,
            // min:lineChart2Info.min, //y轴的最小值
            // max:lineChart2Info.max, //y轴最大值 
            // interval:lineChart2Info.interval, //值之间的间隔
            nameTextStyle:{
              padding:[0,0,10,-40],
              color:"#999",
            },
            splitLine:{
                show: true,
                lineStyle:{
                    type:'dashed',
                    color:"#ddd",
                    width:0.6
                },
            },//去除网格线
            axisLabel:{
              formatter:function (value) {
                var txt=[]
                if(value>=10000){
                  txt.push(value/10000+'w')
                }else{
                  txt.push(value)
                }
                return txt
              },
              textStyle: {
                color: '#999', //坐标值得具体的颜色
              }
            },
            axisLine:{
                show:false//去除y轴线
            },
            axisTick:{
                show:false//去除y轴刻度
            },
        },
        //折线图区域颜色渐变
        series: seriesObj,
      })    
    },

    
  },
  components:{
   
  },
  watch:{
    
  },
  mounted() {
    this.lineChart2(this.lineChart2Info)
  }
}
</script>

<style scoped>
  

</style>